module.exports = __webpack_public_path__ + "static/media/1015515.8b0331da.png";